import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState, useCallback } from "react";
import as from '../../../assets/popup/annual sales.png';
import Deliver from '../../../assets/popup/Deliver.png';
import bill from '../../../assets/popup/to bill.png';
import customer from '../../../assets/popup/customer.png';
import Header from "../../../Components/Header";
import Footer from "../../../Components/Footer";
import GetIcon from "../../../utils/Icon";
import ReactBarChart from "../../../utils/Dashboard/Chart/BarChart";
import { formatIndianPrice } from "../../../utils/formatIndianPrice";
import ReactLineChart from "../../../utils/Dashboard/Chart/LineChart";
import ReactDonutChart from "../../../utils/Dashboard/Chart/DonutChart";
import CartFilterPopup from "./Components/Cart_Filter_Popup";
import ChartFilterPopup from "../../../utils/Dashboard/Chart_Filter_Popup";
import { useGetSelectedCompanyQuery } from "../../../store/api/companyapi";
import { usePostDashboardChartMutation, usePostDashboardChartTwoMutation,
usePostDashboardCountMutation, usePostDashboardPercentageCountMutation,usePostSaveFilterMutation } from "../../../store/api/dashboard";
import {
  Active_Customer_Count_Payload,
  Annual_Purchase_Count_Payload,
  createFilterState,
  Purchase_Order_to_Bill_Count_Payload,
  Purchase_Orders_to_Deliver_Count_Payload
} from "./utils/DashboardData";
import Tabs from "../../../Components/Tabs";
import { Helmet } from "react-helmet";


const Dashboard = () => {
  // API hooks
  const [ChartDataApi] = usePostDashboardChartMutation();
  const [ChartDataApi2] = usePostDashboardChartTwoMutation();
  const [CountApi] = usePostDashboardCountMutation();
  const [SaveFilterApi] = usePostSaveFilterMutation();
  const [CountPercentageApi] = usePostDashboardPercentageCountMutation();
  const { data } = useGetSelectedCompanyQuery();
  const selectedComapny = data?.message?.data?.company.split(' - ')[0];

  // UI state
  const [showpopup, setShowpopup] = useState(false);
  const [showChartPopup, setShowChartPopup] = useState(false);
  const [currentChartType, setCurrentChartType] = useState(null);
  const [currentFilterType, setCurrentFilterType] = useState(null);

  // Chart State
  const [Purchase_order_trends, setPurchase_order_trends] = useState({});
  const [Material_Request_Analysis, setMaterial_Request_Analysis] = useState({});
  const [Purchase_order_analysis, setPurchase_order_analysis] = useState({});
  const [item_wise_annual_Purchase, setitem_wise_annual_Purchase] = useState({});

  // Count State 
  const initialCountState = { count: 0, percentage: 0 };
  const [AnnualPurchaseCount, setAnnualPurchaseCount] = useState(initialCountState);
  const [ActiveSuppliersCount, setActiveSuppliersCount] = useState(initialCountState);
  const [PurchaseOrderstoBillCount, setPurchaseOrderstoBillCount] = useState(initialCountState);
  const [PurchaseOrderstoReceiveCount, setPurchaseOrderstoReceiveCount] = useState(initialCountState);

  // Filter States (initialize with your createFilterState helper where needed)
  const [Annual_Purchase_Filters, setAnnual_Purchase_Filters] = useState(createFilterState('Monthly',{ statusFilters: [] }));
  const [Active_Suppliers_Filters, setActive_Suppliers_Filters] = useState(createFilterState('Monthly',{ statusFilters: [] }));
  const [Purchase_Order_to_Bill_Filters, setPurchase_Order_to_Bill_Filters] = useState(createFilterState('Weekly', { statusFilters: [] }));
  const [Purchase_Order_to_Receive_Filters, setPurchase_Order_to_Receive_Filters] = useState(createFilterState('Weekly', { statusFilters: [] }));
  const [PurchaseOrderTrendsFilters, setPurchaseOrderTrendsFilters] = useState({period: "Monthly",based_on: "Item",fiscal_year: "2025-2026",company: selectedComapny});
  const [ReceiveTrendsFilters, setReceiveTrendsFilters] = useState({period: "quarter",based_on: "Customer",fiscal_year: "2025-2026",company: selectedComapny});

  console.log("ReceiveTrendsFiltersReceiveTrendsFiltersReceiveTrendsFilters",PurchaseOrderTrendsFilters);
  const [PurchaseOrderAnalysisFilters, setPurchaseOrderAnalysisFilters] = useState({from_date: "", to_date: "",status: [], company: selectedComapny});
  const [ItemWiseAnnualPurchaseFilters, setItemWiseAnnualPurchaseFilters] = useState({from_date: "",to_date: "",company: selectedComapny});

  // Helper functions
  const getCurrentChartFilters = useCallback(() => {
    const chartFilters = {
      "Purchase_Order_Trends": PurchaseOrderTrendsFilters,
      "Material_Request_Analysis": ReceiveTrendsFilters,
      "Purchase_Order_Analysis": PurchaseOrderAnalysisFilters,
      "Item_Wise_Annual_Purchase": ItemWiseAnnualPurchaseFilters
    };
    return chartFilters[currentChartType] || {};
  }, [currentChartType, PurchaseOrderTrendsFilters, ReceiveTrendsFilters, PurchaseOrderAnalysisFilters, ItemWiseAnnualPurchaseFilters]);

  const getCurrentFilters = useCallback(() => {
    const cardFilters = {
      'Annual_Purchase': Annual_Purchase_Filters,
      'Active_Suppliers': Active_Suppliers_Filters,
      'Purchase_Order_to_Bill': Purchase_Order_to_Bill_Filters,
      'Purchase_Orders_to_Receive': Purchase_Order_to_Receive_Filters
    };
    return cardFilters[currentFilterType] || {};
  }, [currentFilterType, Annual_Purchase_Filters, Active_Suppliers_Filters, Purchase_Order_to_Bill_Filters, Purchase_Order_to_Receive_Filters]);

  const updateFilters = useCallback((filterType, newFilters) => {
    const filterSetters = {
      // Card Filters
      'Annual_Purchase': setAnnual_Purchase_Filters,
      'Active_Suppliers': setActive_Suppliers_Filters,
      'Purchase_Order_to_Bill': setPurchase_Order_to_Bill_Filters,
      'Purchase_Orders_to_Receive': setPurchase_Order_to_Receive_Filters,
      // Chart Filters
      'Purchase_Order_Trends': setPurchaseOrderTrendsFilters,
      'Material_Request_Analysis': setReceiveTrendsFilters,
      'Purchase_Order_Analysis': setPurchaseOrderAnalysisFilters,
      'Item_Wise_Annual_Purchase': setItemWiseAnnualPurchaseFilters
    };
    const setter = filterSetters[filterType];
    if (setter) {
      setter(prev => ({ ...prev, ...newFilters }));
    }
  }, []);


    const Save_Filter = useCallback(async (docData, filtersData, Count) => {
    if (!selectedComapny) return;
    
    try {
      const formData = new FormData();
      formData.append('doc', JSON.stringify(docData));
      formData.append('action', "Save");
  
      const response = await SaveFilterApi(formData);
       console.log("check save filter response is here",response);
    } catch (error) {
      console.error("Error in Find_Annual_Purchase_Count:", error);
    }
  }, [SaveFilterApi, selectedComapny]);

  const Find_Annual_Purchase_Count = useCallback(async (docData, filtersData, Count, percentage) => {
    if (!selectedComapny) return;
    
    try {
      const formData = new FormData();
      formData.append('doc', JSON.stringify(docData));
      formData.append('filters', JSON.stringify(filtersData));
  
      const response = await CountApi(formData);
      if (percentage) {
        await Find_Annual_Purchase_Count_Percetage(docData, filtersData, response.data.message, Count);
      } else {
        Count(response.data.message);
      }
    } catch (error) {
      console.error("Error in Find_Annual_Purchase_Count:", error);
    }
  }, [CountApi, selectedComapny]);

  const Find_Annual_Purchase_Count_Percetage = useCallback(async (docData, filtersData, countvalue, Count) => {
    try {
      const formData = new FormData();
      formData.append('doc', JSON.stringify(docData));
      formData.append('filters', JSON.stringify(filtersData));
      formData.append('result', JSON.stringify(countvalue));
  
      const response = await CountPercentageApi(formData);
      Count({ count: countvalue, percentage: response.data.message });
    } catch (error) {
      console.error("Error in Find_Annual_Purchase_Count_Percetage:", error);
    }
  }, [CountPercentageApi]);

  const ChartApi = useCallback(async (filter, setState, apiCall) => {
    if (!selectedComapny) return;
    try {
      const response = await apiCall(filter);
      setState(response.data.message);
    } catch (error) {
      console.error(`Error fetching :`, error);
    }
  }, [ChartDataApi, ChartDataApi2, selectedComapny]);

  // --------- Effects for charts and counts (these mirror your original logic) ----------
  useEffect(() => {
    if (!selectedComapny) return;
   console.log("ReceiveTrendsFilters check status filters",ReceiveTrendsFilters);
    const { period, fiscal_year, based_on,status } = ReceiveTrendsFilters;
    let darray;
    if(ReceiveTrendsFilters.status){
      darray = [...ReceiveTrendsFilters?.status];
    }else{
      darray = ["Draft", "Cancelled", "Stopped"];
    }
    const filters = [
      ["Material Request", "status", "not in", darray, false],
      // ["Material Request", "status", "in", [...ReceiveTrendsFilters?.status], false],
      ["Material Request", "material_request_type", "=", "Purchase", false],
      ["Material Request", "docstatus", "=", "1", false],
      ["Material Request", "company", "=", "Stackerbee", false]
    ];
    const formData = new FormData();
    formData.append("chart_name", "Material Request Analysis");
    formData.append("filters", JSON.stringify(filters));

    ChartApi(
       formData, 
      setMaterial_Request_Analysis,
      ChartDataApi2
    );
  }, [ReceiveTrendsFilters, selectedComapny, ChartApi]);

  useEffect(() => {
    if (!selectedComapny) return;
    const { period, fiscal_year, based_on } = PurchaseOrderTrendsFilters;
    const filters = {
      "period":period,
      "based_on":"Item",
      "fiscal_year":fiscal_year,
      "company":selectedComapny
    };
    const formData = new FormData();
    formData.append("report_name", "Purchase Order Trends");
    formData.append("filters", JSON.stringify(filters));
    formData.append("ignore_prepared_report",1);

    ChartApi(
      formData,
      setPurchase_order_trends,
      ChartDataApi
    );
  }, [PurchaseOrderTrendsFilters, selectedComapny, ChartApi]);

  useEffect(() => {
    if (!selectedComapny) return;
    const { period,to_date, from_date,fiscal_year,status } = PurchaseOrderAnalysisFilters;
    console.log("PurchaseOrderAnalysisFiltersPurchaseOrderAnalysisFilters",PurchaseOrderAnalysisFilters);
    const filters = {
      "period":period,
      "group_by_po":0,
      "company":selectedComapny,
      "from_date":from_date,
      "to_date":to_date,
      "fiscal_year":fiscal_year
    };
    const formData = new FormData();
    formData.append("report_name", "Purchase Order Analysis");
    formData.append("filters", JSON.stringify(filters));
    formData.append("ignore_prepared_report",1);

    ChartApi(
      formData,
      setPurchase_order_analysis,
      ChartDataApi
    );
  }, [PurchaseOrderAnalysisFilters, selectedComapny, ChartApi]);

  useEffect(() => {
    if (!selectedComapny) return;
    const { period, fiscal_year, based_on } = PurchaseOrderTrendsFilters;
    const filters = {
      "period":period,
      "based_on":"Supplier",
      "period_based_on":"posting_date",
      "fiscal_year":fiscal_year,
      "company":selectedComapny
    };
    const formData = new FormData();
    formData.append("report_name", "Purchase Receipt Trends");
    formData.append("filters", JSON.stringify(filters));
    formData.append("ignore_prepared_report",1);

    ChartApi(
      formData,
      setitem_wise_annual_Purchase,
      ChartDataApi
    );
  }, [ItemWiseAnnualPurchaseFilters, selectedComapny, ChartApi]);


  function formatDate(date) {
  const pad = (num, size = 2) => String(num).padStart(size, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  const millis = String(date.getMilliseconds()).padStart(6, "0"); // microseconds format (6 digits)

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${millis}`;
}
  // For Purchase Orders to Receive
  useEffect(() => {
    if (!selectedComapny) return;

    const { timeInterval, dateFilters, statusFilters } = Purchase_Order_to_Receive_Filters;
    const fromDate = dateFilters.find(f => f.label === "From Date")?.value;
    const toDate = dateFilters.find(f => f.label === "To Date")?.value;

    const doc = { ...Purchase_Orders_to_Deliver_Count_Payload, stats_time_interval: timeInterval,dynamic_filters_json: JSON.stringify([["Purchase Order", "company", "=", selectedComapny]]), };
    const filters = [
      ["Purchase Order", "company", "=", selectedComapny],
    ];

    if (fromDate && toDate) {
      filters.push(["Purchase Order", "modified", "Between", [fromDate, toDate], false]);
    }

    // If there are normal statusFilters, add them (wms_status would be separate)
    const normalStatus = (statusFilters || []).filter(s => s !== "Partially Receipt");
    if (normalStatus.length) {
      filters.push(["Purchase Order", "status", "in", normalStatus, false]);
    }

    // If wms_status set (we store as wms_status inside Purchase_Order_to_Receive_Filters when user picked Partially Receipt),
    // add mapping here as well:
    if (Purchase_Order_to_Receive_Filters.wms_status && Purchase_Order_to_Receive_Filters.wms_status.length) {
      filters.push(["Purchase Order", "wms_status", "in", Purchase_Order_to_Receive_Filters.wms_status, false]);
    }else{
      filters.push(["Purchase Order","docstatus","=","1",false]);
    }

  const fitlerdata = {
  name: "Purchase Orders to Receive",
  owner: "Administrator",
  // creation: "2020-07-20 21:01:02.438012",
  // modified: formatDate(new Date()),
  // modified_by: "bhumikad878@gmail.com",
  docstatus: 0,
  // idx: 3,
  is_standard: 1,
  module: "Buying",
  label: "Purchase ",
  type: "Document Type",
  function: "Count",
  document_type: "Purchase Order",
  is_public: 1,
  show_percentage_stats: 1,
  stats_time_interval: timeInterval,
  filters_json: '[["Purchase Order","docstatus","=","1",false]]',
  dynamic_filters_json: '[["Purchase Order","company","=","frappe.defaults.get_user_default(\\"Company\\")"]]',
  // dynamic_filters_json: `[["Purchase Order","company","=","${selectedComapny}"]]`,
  doctype: "Number Card",
  // __last_sync_on: new Date(),
  // __unsaved: 1
};


    Save_Filter(fitlerdata, filters, setPurchaseOrderstoReceiveCount );
    Find_Annual_Purchase_Count(doc, filters, setPurchaseOrderstoReceiveCount, true);
  }, [Purchase_Order_to_Receive_Filters, selectedComapny, Find_Annual_Purchase_Count]);

  // For Purchase Orders to Bill
  useEffect(() => {
    if (!selectedComapny) return;

    const { timeInterval, dateFilters, statusFilters } = Purchase_Order_to_Bill_Filters;
    const fromDate = dateFilters.find(f => f.label === "From Date")?.value;
    const toDate = dateFilters.find(f => f.label === "To Date")?.value;

    const doc = { ...Purchase_Order_to_Bill_Count_Payload, stats_time_interval: timeInterval };
    const filters = [
      ["Purchase Order", "company", "=", selectedComapny],
      ["Purchase Order", "docstatus", "=", 1, false]
    ];

    // Add normal statuses
    const normalStatus = (statusFilters || []).filter(s => s !== "Partially Receipt");
    if (normalStatus.length) {
      filters.push(["Purchase Order", "status", "in", normalStatus, false]);
    }

    // wms_status handling
    if (Purchase_Order_to_Bill_Filters.wms_status && Purchase_Order_to_Bill_Filters.wms_status.length) {
      filters.push(["Purchase Order", "wms_status", "in", Purchase_Order_to_Bill_Filters.wms_status, false]);
    }

    if (fromDate && toDate) {
      filters.push(["Purchase Order", "modified", "Between", [fromDate, toDate], false]);
    }

    Find_Annual_Purchase_Count(doc, filters, setPurchaseOrderstoBillCount, true);
  }, [Purchase_Order_to_Bill_Filters, selectedComapny, Find_Annual_Purchase_Count]);

  // For Active Suppliers
  useEffect(() => {
    if (!selectedComapny) return;

    const { timeInterval, dateFilters } = Active_Suppliers_Filters;
    const fromDate = dateFilters.find(f => f.label === "From Date")?.value;
    const toDate = dateFilters.find(f => f.label === "To Date")?.value;

    const doc = { ...Active_Customer_Count_Payload, stats_time_interval: timeInterval };
    const filters = [
      ["Supplier", "disabled", "=", "0"]
    ];

    if (fromDate && toDate) {
      filters.push(["Supplier", "creation", "Between", [fromDate, toDate], false]);
    }

    Find_Annual_Purchase_Count(doc, filters, setActiveSuppliersCount, true);
  }, [Active_Suppliers_Filters, selectedComapny, Find_Annual_Purchase_Count]);

  // For Annual Purchase
  useEffect(() => {
    if (!selectedComapny) return;

    const { timeInterval, dateFilters, statusFilters } = Annual_Purchase_Filters;
    const fromDate = dateFilters.find(f => f.label === "From Date")?.value;
    const toDate = dateFilters.find(f => f.label === "To Date")?.value;

    const doc = { ...Annual_Purchase_Count_Payload, stats_time_interval: timeInterval };
    const filters = [
      ["Purchase Order", "company", "=", selectedComapny, false],
      ["Purchase Order", "docstatus", "=", "1", false]
    ];

    // Add normal statuses
    const normalStatus = (statusFilters || []).filter(s => s !== "Partially Receipt");
    if (normalStatus.length) {
      filters.push(["Purchase Order", "status", "in", normalStatus, false]);
    }

    // Add wms_status if provided
    if (Annual_Purchase_Filters.wms_status && Annual_Purchase_Filters.wms_status.length) {
      filters.push(["Purchase Order", "wms_status", "in", Annual_Purchase_Filters.wms_status, false]);
    }

    if (fromDate && toDate) {
      filters.push(["Purchase Order", "transaction_date", "Between", [fromDate, toDate], false]);
    }

    Find_Annual_Purchase_Count(doc, filters, setAnnualPurchaseCount, true);
  }, [Annual_Purchase_Filters, selectedComapny, Find_Annual_Purchase_Count]);


  // ---------- Dashboard cards data (each card can have its own status options) ----------
  const allfilter = [
    { label: "Draft", value: "Draft" },
    { label: "On Hold", value: "On Hold" },
    { label: "To Deliver and Bill", value: "To Deliver and Bill" },
    { label: "To Bill", value: "To Bill" },
    { label: "To Deliver", value: "To Deliver" },
    { label: "Completed", value: "Completed" },
    { label: "Cancelled", value: "Cancelled" },
    { label: "Closed", value: "Closed" },
    // include the special one you mentioned
    { label: "Partially Receipt", value: "Partially Receipt" },
    { label: "Completely Receipt", value: "Completely Receipt" },
    { label: "Confirmed For Submitted", value: "Confirmed For Submitted" },
  ];

  // Default per-card status (you can customize)
  const defaultStatusForCard = {
    'Annual_Purchase': ["To Bill","To Deliver and Bill"],
    'Purchase_Orders_to_Receive': ["To Deliver"],
    'Purchase_Order_to_Bill': ["To Bill","To Deliver and Bill"],
    'Active_Suppliers': [] // no statuses for suppliers
  };

  const dashboardCards = [
    {
      title: "Annual Purchase Order",
      filterType: "Annual_Purchase",
      timeInterval: Annual_Purchase_Filters.timeInterval,
      value: `₹${formatIndianPrice(AnnualPurchaseCount.count)}`,
      tooltip: `₹${Number(AnnualPurchaseCount.count).toLocaleString('en-IN')}`,
      percentage: AnnualPurchaseCount?.percentage?.toFixed(2) || 0,
      icon: as,
      iconBg: '#fe8d5c',
      statusOptions: allfilter,
      defaultStatus: defaultStatusForCard['Annual_Purchase'] || []
    },
    {
      title: "Purchase Orders to Receive",
      filterType: "Purchase_Orders_to_Receive",
      timeInterval: Purchase_Order_to_Receive_Filters.timeInterval,
      value: PurchaseOrderstoReceiveCount.count,
      tooltip: PurchaseOrderstoReceiveCount.count,
      percentage: PurchaseOrderstoReceiveCount?.percentage?.toFixed(2) || 0,
      icon: Deliver,
      iconBg: '#823455',
      statusOptions: allfilter,
      defaultStatus: defaultStatusForCard['Purchase_Orders_to_Receive'] || []
    },
    {
      title: "Purchase Orders to Bill",
      filterType: "Purchase_Order_to_Bill",
      timeInterval: Purchase_Order_to_Bill_Filters.timeInterval,
      value: PurchaseOrderstoBillCount.count,
      tooltip: PurchaseOrderstoBillCount.count,
      percentage: PurchaseOrderstoBillCount?.percentage?.toFixed(2) || 0,
      icon: bill,
      iconBg: '#391f84',
      statusOptions: allfilter,
      defaultStatus: defaultStatusForCard['Purchase_Order_to_Bill'] || []
    },
    {
      title: "Active Suppliers",
      filterType: "Active_Suppliers",
      timeInterval: Active_Suppliers_Filters.timeInterval,
      value: ActiveSuppliersCount.count,
      tooltip: ActiveSuppliersCount.count,
      percentage: ActiveSuppliersCount?.percentage?.toFixed(2) || 0,
      icon: customer,
      iconBg: '#fe8d5c',
      statusOptions: [], // no statuses
      defaultStatus: []
    }
  ];

  const charts = [
    {
      type: "Purchase_Order_Trends",
      title: "Purchase Order Trends",
      component: <ReactLineChart data={Purchase_order_trends} />,
      fields: ["period", "fiscal_year"]
    },
    {
      type: "Purchase_Order_Analysis",
      title: "Purchase Order Analysis",
      component: <ReactDonutChart data={Purchase_order_analysis} />,
      fields: ["from_date", "to_date", "status", "period", "fiscal_year"]
    },
     {
      type: "Material_Request_Analysis",
      title: "Material Request Analysis",
      component: <ReactDonutChart data={!Material_Request_Analysis?.labels ? {} : {chart:{data:{labels:[Material_Request_Analysis?.labels],datasets:[{values:Material_Request_Analysis?.datasets?.[0]?.values}]}}}} />,
      fields: ["status"]
    },
    {
      type: "Purchase_Order_Trends",
      title: "Top Suppliers",
      component: <ReactBarChart data={item_wise_annual_Purchase} color={'#391f84'} />,
      fields: ["period", "fiscal_year"]
    }
  ];
  const pageTitle = "Inbound Dashboard"
  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Header />
      <div className="container-fluid dashboard-container py-0">
         <Tabs />
        <div className="row dashboard-header py-2" style={{ marginBottom: "0px" }}>
          <div className="col-12">
            <h5 className="mb-0" style={{ color: "#823455" }}>Inbound Dashboard</h5>
          </div>
        </div>

        <div className="row mb-4">
          {dashboardCards.map((card, index) => (
            <div className="col-md-3" key={index}>
              <div className="dashboard_card" style={{ backgroundColor: '#fff' }}>
                <h6 className="dashboard-card-p1 d-flex justify-content-between">
                  <span>{card.title}</span>
                  <span className="threedotsishere" onClick={() => { 
                    setCurrentFilterType(card.filterType); 
                    setShowpopup(true); 
                  }}>
                    <GetIcon iconName="IoFilterSharp" size={15} />
                  </span>
                </h6>
                <p className="dashboard-card-p2 custom-tooltip">
                  {card.value}
                  <span className="tooltip-text">{card.tooltip}</span>
                  <span className="dashboard-icon" style={{ backgroundColor: card.iconBg }}>
                    <img src={card.icon} alt="404" />
                  </span>
                </p>
                <p className="dashboard-card-p3">{card.percentage}% since last {card.timeInterval}</p>
              </div>
            </div>
          ))}
        </div>

        {[0, 2].map((startIdx) => (
          <div className="row mb-4" key={startIdx}>
            {charts.slice(startIdx, startIdx + 2).map((chart) => (
              <div className="col-md-6" key={chart.type}>
                <div className="dashboard-card m-0" style={{ height: "100%" }}>
                  <h5 className="d-flex justify-content-between" style={{ fontSize: "15px", fontWeight: "700" }}>
                    <span>{chart.title}</span>
                    <span 
                      onClick={() => { 
                        setCurrentChartType(chart.type); 
                        setShowChartPopup(true); 
                      }} 
                      style={{ cursor: "pointer" }}
                    >
                      <GetIcon iconName="IoFilterSharp" size={15} />
                    </span>
                  </h5>
                  {chart.component}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      <ChartFilterPopup
        show={showChartPopup}
        onClose={() => setShowChartPopup(false)}
        filters={getCurrentChartFilters()}
        setFilters={(newFilters) => updateFilters(currentChartType, newFilters)}
        fields={charts.find(c => c.type === currentChartType)?.fields || []}
      />

      <CartFilterPopup
        show={showpopup}
        onClose={() => setShowpopup(false)}
        // pass in the current filters for the selected card
        filters={getCurrentFilters()}
        setFilters={(newFilters) => updateFilters(currentFilterType, newFilters)}
        cardType={currentFilterType}
        // provide the status options & default status for the card to the popup so UI shows correct options
        statusOptions={dashboardCards.find(c => c.filterType === currentFilterType)?.statusOptions || []}
        defaultStatus={dashboardCards.find(c => c.filterType === currentFilterType)?.defaultStatus || []}
      />

      <Footer /> 
      </div>
    </>
  );
};

export default Dashboard;
